import React, { Component } from 'react';

class IamExUsEventRow extends Component {

  state = {

  };

  componentDidMount() {

  };

  render() {

    const {event} = this.props;

    return (
      <tr className="IamExUsEventRowPage" onClick={() => console.log(event)}>
        <td>{event.awsRegion}</td>
        <td>{event.eventName}</td>
        <td>{event.eventSource}</td>
        <td>{event.eventTime}</td>
        <td>{event.eventType}</td>
        <td>{event.userIdentity.accessKeyId}</td>
      </tr>
    );

  };

};

export default IamExUsEventRow;


// WEBPACK FOOTER //
// ./src/components/content/iamExplorer/iamExUsers/iamExUsContent/iamExUsEventRow/iamExUsEventRow.js